module.exports = __webpack_public_path__ + "40d931acf52bcc8bfc443fde6a383a38.png";